/**
 * useImmersiveTabBar - Memoized ImmersiveTabBar element for immersive pages
 * Eliminates duplicate useMemo boilerplate in ImmersiveHome and ImmersiveEntityDetail.
 * Returns a React element via createElement (no JSX — .js file).
 *
 * @atomic @idempotent
 */
import { useMemo, createElement } from 'react'
import { useTranslation } from 'react-i18next'
import { TruckIcon, BoltIcon } from '@heroicons/react/24/outline'
import ImmersiveTabBar from '../components/ImmersiveTabBar'

export function useImmersiveTabBar({
  activeTab,
  panelState,
  handleTabClick,
  isAuthenticated,
  unreadChannelCount,
  isVendor,
  language,
  prependElement = null,
}) {
  const { t } = useTranslation()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => createElement(ImmersiveTabBar, {
    activeTab,
    panelState,
    onTabClick: handleTabClick,
    isAuthenticated,
    badges: { contact: unreadChannelCount },
    extraTabs: [
      { id: 'live', icon: BoltIcon, label: t('nav.live', 'Live') },
      ...(isVendor ? [{ id: 'vendor', icon: TruckIcon, label: t('nav.manage', 'Manage') }] : []),
    ],
    prependElement,
  }), [activeTab, panelState, handleTabClick, isAuthenticated, unreadChannelCount, isVendor, prependElement])
}
